var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("kotsuhi-menu"),
      _vm._v(" "),
      _vm.hasAnyRole("ROLE_ADMIN", "ROLE_KOTSUHI_READ", "ROLE_KOTSUHI_ADMIN")
        ? _c(
            "div",
            { staticClass: "col-md-10 pt-3" },
            [
              _c("div", [
                _c("div", { staticClass: "form-group" }, [
                  _c("span", { staticStyle: { "margin-left": "15px" } }, [
                    _vm._v("年")
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedYear,
                          expression: "selectedYear"
                        }
                      ],
                      staticClass: "search-select custom-select",
                      attrs: { name: "year" },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedYear = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.changeSelected
                        ]
                      }
                    },
                    _vm._l(_vm.yearList, function(year) {
                      return _c(
                        "option",
                        { key: year, domProps: { value: year } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(year) +
                              "\n                "
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "margin-left": "15px" } }, [
                    _vm._v("月")
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedMonth,
                          expression: "selectedMonth"
                        }
                      ],
                      staticClass: "search-select custom-select",
                      attrs: { name: "month" },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedMonth = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.changeSelected
                        ]
                      }
                    },
                    _vm._l(12, function(month) {
                      return _c(
                        "option",
                        { key: month, domProps: { value: month } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(month) +
                              "\n                "
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "margin-left": "15px" } }, [
                    _vm._v("部署")
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedDepartmentId,
                          expression: "selectedDepartmentId"
                        }
                      ],
                      staticClass: "search-select custom-select",
                      attrs: { name: "department" },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedDepartmentId = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.changeSelected
                        ]
                      }
                    },
                    [
                      _vm.hasAnyRole("ROLE_ADMIN", "ROLE_MANAGE")
                        ? _c(
                            "option",
                            { attrs: { value: "", selected: "selected" } },
                            [_vm._v("すべて")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.loginUser.departmentList, function(
                        current,
                        index
                      ) {
                        return _c(
                          "option",
                          {
                            key: index,
                            domProps: {
                              value: _vm.loginUser.departmentIdList[index]
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(current) +
                                "\n                "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "margin-left": "5px" } }, [
                    _vm._v("ユーザ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedUserId,
                          expression: "selectedUserId"
                        }
                      ],
                      staticClass: "search-select custom-select",
                      attrs: { name: "userId" },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedUserId = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.changeSelected
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { selected: "true" } }),
                      _vm._v(" "),
                      _vm._l(_vm.userList, function(user) {
                        return !_vm.isRetiree(user.deletedAt)
                          ? _c(
                              "option",
                              {
                                key: user.userId,
                                domProps: { value: user.userId }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(user.userName) +
                                    "\n                "
                                )
                              ]
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "margin-left": "5px" } }, [
                    _vm._v("ステータス")
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedStatus,
                          expression: "selectedStatus"
                        }
                      ],
                      staticClass: "search-select custom-select",
                      attrs: { name: "status" },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedStatus = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.changeSelected
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { selected: "true" } }),
                      _vm._v(" "),
                      _vm._l(_vm.statusList, function(status) {
                        return _c(
                          "option",
                          { key: status, domProps: { value: status } },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(status) +
                                "\n                "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.hasAnyRole("ROLE_ADMIN", "ROLE_KOTSUHI_ADMIN")
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-sm m-1",
                      attrs: {
                        id: "kotsuhiBulkApproval",
                        disabled: "disabled"
                      },
                      on: {
                        click: function($event) {
                          return _vm.bulkConfirm()
                        }
                      }
                    },
                    [_vm._v("\n      一括承認\n    ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasAnyRole("ROLE_ADMIN", "ROLE_KOTSUHI_ADMIN")
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-success btn-sm",
                      attrs: { id: "kotsuhiBulkPaid", disabled: "disabled" },
                      on: {
                        click: function($event) {
                          return _vm.bulkPaidConfirm()
                        }
                      }
                    },
                    [_vm._v("\n      一括精算\n    ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("modal", {
                ref: "bulkConfirm",
                on: {
                  ok: function($event) {
                    return _vm.bulkStatusUpdate("confirm")
                  }
                }
              }),
              _vm._v(" "),
              _c("modal", {
                ref: "bulkPaid",
                on: {
                  ok: function($event) {
                    return _vm.bulkStatusUpdate("paid")
                  }
                }
              }),
              _vm._v(" "),
              _vm.containPaid
                ? _c("span", { staticClass: "text-danger" }, [
                    _vm._v("*すでに精算済みのものはステース変更されません。")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.kotsuhiList.length == 0
                ? _c("div", [_vm._v("まだレコードはありません")])
                : _c("div", [
                    _c(
                      "table",
                      { staticClass: "table table-bordered table-responsive" },
                      [
                        _c("thead", { staticClass: "thead-light" }, [
                          _c("tr", [
                            _c("th", [
                              _c("div", { staticClass: "checkbox noflap" }, [
                                _c("label", [
                                  _c("input", {
                                    attrs: {
                                      type: "checkbox",
                                      id: "kotsuhiAllCheck"
                                    },
                                    on: { click: _vm.checkAll }
                                  }),
                                  _vm._v(" "),
                                  _vm._m(0)
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("th", [_vm._v("氏名")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("対象日")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("出発駅")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("到着駅")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("使用路線")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("料金種類")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("利用用途")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("費用")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("ステータス")]),
                            _vm._v(" "),
                            _vm.hasAnyRole("ROLE_ADMIN", "ROLE_KOTSUHI_ADMIN")
                              ? _c("th", [_vm._v("承認/取消")])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("th", [_vm._v("申請日")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("申請書(EXCEL)")]),
                            _vm._v(" "),
                            _vm.hasAnyRole("ROLE_ADMIN", "ROLE_KOTSUHI_ADMIN")
                              ? _c("th", [_vm._v("削除")])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.kotsuhiList, function(result, index) {
                            return _c(
                              "tr",
                              {
                                key: index,
                                class: { retiree: result.userDeletedAt }
                              },
                              [
                                _c("td", [
                                  _c(
                                    "div",
                                    { staticClass: "checkbox noflap" },
                                    [
                                      _c("label", [
                                        _c("input", {
                                          staticClass: "kotsuhiCheck",
                                          attrs: {
                                            type: "checkbox",
                                            name: "idList",
                                            "data-status": result.status
                                          },
                                          domProps: { value: result.id },
                                          on: { click: _vm.checkSingle }
                                        }),
                                        _vm._v(" "),
                                        _vm._m(1, true)
                                      ])
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(result.userName) +
                                      "\n                        "
                                  ),
                                  result.userDeletedAt
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "badge badge-secondary"
                                        },
                                        [_vm._v("退職")]
                                      )
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(result.targetDate))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(result.startStation))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(result.endStation))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(result.route))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(result.type))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(result.useType))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(result.expense))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(result.status))]),
                                _vm._v(" "),
                                _vm.hasAnyRole(
                                  "ROLE_ADMIN",
                                  "ROLE_KOTSUHI_ADMIN"
                                )
                                  ? _c("td", [
                                      _vm.hasAnyRole(
                                        "ROLE_ADMIN",
                                        "ROLE_YUKYU_ADMIN"
                                      )
                                        ? _c("div", [
                                            result.status === "申請中" ||
                                            result.status === "差し戻し"
                                              ? _c("div", [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-primary btn-sm",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.updateStatus(
                                                            "confirm",
                                                            result.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("承認")]
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            result.status === "承認済み"
                                              ? _c("div", [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-sm btn-success",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.updateStatus(
                                                            "paid",
                                                            result.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("精算")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-sm btn-outline-dark",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.updateStatus(
                                                            "remand",
                                                            result.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("差し戻し")]
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            result.status === "精算済み"
                                              ? _c("div", [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-check fa-1x",
                                                    attrs: {
                                                      "aria-hidden": "true"
                                                    }
                                                  })
                                                ])
                                              : _vm._e()
                                          ])
                                        : _vm._e()
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(result.createdDate))]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-info",
                                      staticStyle: { "border-radius": "50px" },
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.download(
                                            "/api/kotsuhi/download/" +
                                              _vm.selectedYear +
                                              "/" +
                                              _vm.selectedMonth +
                                              "/" +
                                              result.userId +
                                              "/excel"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            ダウンロード\n                        "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.hasAnyRole(
                                  "ROLE_ADMIN",
                                  "ROLE_KOTSUHI_ADMIN"
                                )
                                  ? _c("td", [
                                      _vm.hasAnyRole(
                                        "ROLE_ADMIN",
                                        "ROLE_YUKYU_ADMIN"
                                      )
                                        ? _c("div", [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-outline-danger btn-sm",
                                                attrs: {
                                                  type: "button",
                                                  "data-toggle": "modal",
                                                  "data-target": "#" + result.id
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-trash fa-1x",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                                削除\n                            "
                                                )
                                              ]
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "modal fade",
                                          attrs: {
                                            id: result.id,
                                            tabindex: "-1",
                                            role: "dialog",
                                            "aria-labelledby":
                                              "exampleModal3Label",
                                            "aria-hidden": "true"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "modal-dialog",
                                              attrs: { role: "document" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "modal-content"
                                                },
                                                [
                                                  _vm._m(2, true),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "modal-body"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                        名前\n                                        "
                                                      ),
                                                      _c("p", [
                                                        _vm._v(
                                                          _vm._s(
                                                            result.userName
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(
                                                        "\n                                        対象日\n                                        "
                                                      ),
                                                      _c("p", [
                                                        _vm._v(
                                                          _vm._s(
                                                            result.targetDate
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(
                                                        "\n                                        本当に削除してもよろしいですか？\n                                    "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "modal-footer"
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn-secondary",
                                                          attrs: {
                                                            type: "button",
                                                            "data-dismiss":
                                                              "modal"
                                                          }
                                                        },
                                                        [_vm._v("キャンセル")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn-danger",
                                                          attrs: {
                                                            type: "button"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.kotsuhiDelete(
                                                                result.id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("削除")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-right" },
                [
                  _vm.kotsuhiList.length > 0
                    ? _c("pagination", {
                        attrs: { pagination: _vm.pagination }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "checkbox-material" }, [
      _c("span", { staticClass: "check" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "checkbox-material" }, [
      _c("span", { staticClass: "check" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h5",
        { staticClass: "modal-title", attrs: { id: "exampleModal3Label" } },
        [_vm._v("確認")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e25e59e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e25e59e2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/admin/kotsuhi/KotsuhiList.vue
// module id = 427
// module chunks = 0